var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6364 2.18182H18.5455V0H16.3636V2.18182H5.45455V0H3.27273V2.18182H2.18182C0.981818 2.18182 0 3.16364 0 4.36364V21.8182C0 23.0182 0.981818 24 2.18182 24H19.6364C20.8364 24 21.8182 23.0182 21.8182 21.8182V4.36364C21.8182 3.16364 20.8364 2.18182 19.6364 2.18182ZM19.6364 21.8182H2.18182V7.63636H19.6364V21.8182Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.42bce9d08db9b59dd2698d8d0d5908d5.svg";
export { ForwardRef as ReactComponent };